import { render, staticRenderFns } from "./model-cascader.vue?vue&type=template&id=8c7706be"
import script from "./model-cascader.vue?vue&type=script&lang=js"
export * from "./model-cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports